export default "dist/images/block-pricing-box-plain.8f98d4b.png";